document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.hdr');

  if (header) {
    const syncHeader = () => {
      header.classList.toggle('hdr--scrolled', window.scrollY > 8);
    };

    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });
  }

  document.querySelectorAll('.tc-product-card').forEach((card) => {
    const mainImage = card.querySelector('.card-img:not(.card-img--hover)');
    const hoverImage = card.querySelector('.card-img--hover');
    const swatches = card.querySelectorAll('[data-tc-swatch-src]');

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const swatchImage = swatch.getAttribute('data-tc-swatch-src');

        if (mainImage) {
          mainImage.src = swatchImage;
          mainImage.removeAttribute('srcset');
        }

        if (hoverImage) {
          hoverImage.src = swatchImage;
          hoverImage.removeAttribute('srcset');
        }

        card.querySelectorAll('.swatch').forEach((item) => item.classList.remove('swatch--on'));
        swatch.classList.add('swatch--on');
      });
    });
  });

  const findVariantRadio = (variantId) => {
    if (!variantId) return null;
    return Array.from(document.querySelectorAll('[data-tc-variant-radio]')).find((radio) => radio.value === variantId) || null;
  };

  const setGalleryThumb = (thumb, options = {}) => {
    if (!thumb) return;
    const gallery = thumb.closest('[data-tc-gallery]');
    if (!gallery) return;

    const mainImage = gallery.querySelector('.gal-main-img');
    const zoomTrigger = gallery.querySelector('[data-tc-gallery-zoom-open]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-tc-gallery-src]'));
    const currentIndex = thumbs.indexOf(thumb);
    const image = thumb.getAttribute('data-tc-gallery-src');
    const zoomImage = thumb.getAttribute('data-tc-gallery-zoom-src') || image;
    const title = thumb.getAttribute('data-tc-gallery-title');

    if (mainImage && image) {
      mainImage.src = image;
      mainImage.removeAttribute('srcset');
    }

    if (zoomTrigger && zoomImage) {
      zoomTrigger.setAttribute('data-tc-current-zoom-src', zoomImage);
    }

    if (title) {
      document.querySelectorAll('.gal-colourpill').forEach((item) => { item.textContent = title; });
    }

    thumbs.forEach((item) => item.classList.remove('on'));
    thumb.classList.add('on');

    gallery.querySelectorAll('.gal-dots span').forEach((dot, dotIndex) => {
      dot.classList.toggle('on', dotIndex === currentIndex);
    });

    if (options.syncVariant !== false) {
      const radio = findVariantRadio(thumb.getAttribute('data-tc-gallery-variant-id'));
      if (radio) {
        radio.checked = true;
        applyVariantRadio(radio, { syncGallery: false });
      }
    }
  };

  const setGalleryIndex = (gallery, index) => {
    const thumbs = Array.from(gallery.querySelectorAll('[data-tc-gallery-src]'));
    if (!thumbs.length) return;
    const currentIndex = thumbs.findIndex((thumb) => thumb.classList.contains('on'));
    const nextIndex = ((currentIndex < 0 ? 0 : currentIndex) + index + thumbs.length) % thumbs.length;
    setGalleryThumb(thumbs[nextIndex]);
  };

  const syncGalleryToRadio = (radio) => {
    const gallery = document.querySelector('[data-tc-gallery]');
    if (!gallery) return;
    const thumb = Array.from(gallery.querySelectorAll('[data-tc-gallery-src]')).find((item) => item.getAttribute('data-tc-gallery-variant-id') === radio.value);

    if (thumb) {
      setGalleryThumb(thumb, { syncVariant: false });
    }
  };

  const applyVariantRadio = (radio, options = {}) => {
      const root = radio.closest('.pdp-hero') || document;
      const label = radio.closest('.pdp-sw');
      const image = radio.getAttribute('data-image');

      document.querySelectorAll('.pdp-sw').forEach((item) => item.classList.remove('on'));
      if (label) label.classList.add('on');

      root.querySelectorAll('[data-tc-variant-name]').forEach((item) => { item.textContent = radio.getAttribute('data-title') || ''; });
      root.querySelectorAll('[data-tc-sku]').forEach((item) => { item.textContent = radio.getAttribute('data-sku') || ''; });
      document.querySelectorAll('[data-tc-price], [data-tc-sticky-price]').forEach((item) => { item.textContent = radio.getAttribute('data-price') || ''; });
      document.querySelectorAll('.gal-colourpill').forEach((item) => { item.textContent = radio.getAttribute('data-title') || ''; });

      const inStock = radio.getAttribute('data-available') === 'true';
      const stockPill = document.querySelector('[data-tc-stock-pill]');
      const stockText = document.querySelector('[data-tc-stock-text]');
      const deliveryTitle = document.querySelector('[data-tc-delivery-title]');
      const delivery = document.querySelector('[data-tc-delivery]');
      const buyLabel = document.querySelector('[data-tc-buy-label]');
      const stickyLabel = document.querySelector('[data-tc-sticky-label]');
      const buyButton = document.querySelector('[data-tc-buy-button]');
      const stickyButton = document.querySelector('[data-tc-sticky-button]');
      const preorderInput = document.querySelector('[data-tc-preorder-date-input]');
      const extra = document.querySelector('[data-tc-extra]');
      const stickyCompare = document.querySelector('[data-tc-sticky-compare]');
      const stickyImage = document.querySelector('.pdp-sticky-img');
      const swatchLink = document.querySelector('[data-tc-swatch-link]');
      const disabled = radio.getAttribute('data-disabled') === 'true';
      const preorder = radio.getAttribute('data-preorder') === 'true';
      const preorderDate = radio.getAttribute('data-preorder-date') || '';

      if (stockPill) {
        stockPill.classList.toggle('stockpill--in', inStock && !preorder);
        stockPill.classList.toggle('stockpill--pre', !inStock || preorder);
      }
      if (stockText) stockText.textContent = radio.getAttribute('data-stock') || '';
      if (deliveryTitle) deliveryTitle.textContent = radio.getAttribute('data-delivery-title') || '';
      if (delivery) delivery.innerHTML = radio.getAttribute('data-delivery') || '';
      if (buyLabel) buyLabel.textContent = radio.getAttribute('data-cta') || 'Add to basket';
      if (stickyLabel) stickyLabel.textContent = radio.getAttribute('data-cta') || 'Add to basket';
      if (buyButton) buyButton.disabled = disabled;
      if (stickyButton) stickyButton.disabled = disabled;

      if (preorderInput) {
        preorderInput.value = preorderDate;
        preorderInput.disabled = !preorderDate;
      }

      const compare = document.querySelector('[data-tc-compare]');
      const save = document.querySelector('[data-tc-save]');
      if (compare) {
        compare.textContent = radio.getAttribute('data-compare') || '';
        compare.classList.toggle('hidden', !radio.getAttribute('data-compare'));
      }
      if (save) {
        save.textContent = radio.getAttribute('data-save') || '';
        save.classList.toggle('hidden', !radio.getAttribute('data-save'));
      }
      if (extra) {
        extra.innerHTML = radio.getAttribute('data-extra') || '';
        extra.classList.toggle('hidden', !radio.getAttribute('data-extra'));
      }
      if (stickyCompare) {
        stickyCompare.textContent = radio.getAttribute('data-compare') || '';
        stickyCompare.classList.toggle('hidden', !radio.getAttribute('data-compare'));
      }

      if (image) {
        const mainImage = document.querySelector('.gal-main-img');
        const zoomTrigger = document.querySelector('[data-tc-gallery-zoom-open]');
        if (mainImage) {
          mainImage.src = image;
          mainImage.removeAttribute('srcset');
        }
        if (zoomTrigger) {
          zoomTrigger.setAttribute('data-tc-current-zoom-src', image.replace('width=1400', 'width=2200'));
        }
      }

      if (stickyImage && radio.getAttribute('data-sticky-image')) {
        stickyImage.src = radio.getAttribute('data-sticky-image');
        stickyImage.removeAttribute('srcset');
      }

      if (swatchLink && radio.getAttribute('data-swatch-url')) {
        swatchLink.href = radio.getAttribute('data-swatch-url');
      }

      if (options.syncGallery !== false) {
        syncGalleryToRadio(radio);
      }
  };

  document.querySelectorAll('[data-tc-gallery]').forEach((gallery) => {
    const navButtons = gallery.querySelectorAll('[data-tc-gallery-step]');

    gallery.querySelectorAll('[data-tc-gallery-src]').forEach((thumb) => {
      thumb.addEventListener('click', () => setGalleryThumb(thumb));
    });

    navButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setGalleryIndex(gallery, Number(button.getAttribute('data-tc-gallery-step')));
      });
    });
  });

  document.querySelectorAll('[data-tc-variant-radio]').forEach((radio) => {
    radio.addEventListener('change', () => {
      applyVariantRadio(radio);
    });
  });

  document.querySelectorAll('[data-tc-gallery-zoom-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const modal = document.querySelector('[data-tc-zoom-modal]');
      const zoomImg = document.querySelector('[data-tc-zoom-img]');
      const mainImage = document.querySelector('.gal-main-img');
      if (!modal || !zoomImg) return;

      zoomImg.src = button.getAttribute('data-tc-current-zoom-src') || mainImage?.src || zoomImg.src;
      zoomImg.alt = mainImage?.alt || zoomImg.alt;

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
    });
  });

  document.querySelectorAll('[data-tc-zoom-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const modal = button.closest('[data-tc-zoom-modal]');
      if (modal?.close) {
        modal.close();
      } else if (modal) {
        modal.removeAttribute('open');
      }
    });
  });

  document.querySelectorAll('[data-tc-zoom-modal]').forEach((modal) => {
    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        if (modal.close) {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      }
    });
  });

  const mobileFilters = document.querySelectorAll('[data-tc-mobile-filters]');
  if (mobileFilters.length) {
    const syncMobileFilters = () => {
      const shouldOpen = window.matchMedia('(min-width: 750px)').matches;
      mobileFilters.forEach((filter) => {
        filter.open = shouldOpen;
      });
    };

    syncMobileFilters();
    window.addEventListener('resize', syncMobileFilters);
  }

  document.querySelectorAll('[data-tc-qty]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('.qty')?.querySelector('.tc-qty-input');
      if (!input) return;
      const nextValue = Math.max(1, Number(input.value || 1) + Number(button.getAttribute('data-tc-qty')));
      input.value = String(nextValue);
    });
  });

  const stickyBuy = document.querySelector('[data-tc-sticky-buy]');
  if (stickyBuy) {
    const syncStickyBuy = () => {
      stickyBuy.classList.toggle('on', window.scrollY > 620);
    };

    syncStickyBuy();
    window.addEventListener('scroll', syncStickyBuy, { passive: true });
  }

  document.querySelectorAll('.tc-tabs').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('[data-tc-tab]');
    const panels = tabs.querySelectorAll('[data-tc-panel]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.getAttribute('data-tc-tab');

        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.classList.toggle('on', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const active = panel.getAttribute('data-tc-panel') === target;
          panel.hidden = !active;
        });
      });
    });
  });
});
